import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import speciesName from '../utils/speciesName';
const VISIBLE_STEP = 30;
/**
 * Shared by SpeciesChildrenBox/SpeciesSynonymsBox - both are a sidebar
 * reference box on the species page listing species related to the one
 * being viewed (children or synonyms), fetched once by gbifId and
 * paginated client-side over the already-fetched list ("Charger
 * davantage" - same VISIBLE_STEP convention as DescriptionsPage.js/
 * DeterminationKeysPage.js, since a well-documented species can have 20+
 * of either, sometimes hundreds via ChecklistBank). Both can be either
 * GBIF- or ChecklistBank-sourced depending on the actor's own preference -
 * see SpeciesSynonymsResource/SpeciesChildrenResource's own docblocks, and
 * each item's own colId (only ever set for a ChecklistBank-sourced one).
 *
 * Attrs:
 * - gbifId: the species being viewed.
 * - endpoint: API resource type to fetch (e.g. "species-children"),
 *   filtered by gbifId.
 * - sectionClass/loadMoreClass: wrapper class names (kept distinct per
 *   caller - SpeciesPage-children/-childrenLoadMore vs
 *   SpeciesPage-synonyms/-synonymsLoadMore - so forum.less' existing
 *   per-section rules keep matching without also needing to change).
 * - headerKey: translation key for the section's own <h2>.
 */
export default class SpeciesReferenceBox extends Component {
  items = null;
  visibleCount = (() => VISIBLE_STEP)();
  oninit(vnode) {
    super.oninit(vnode);
    this.items = null;
    this.visibleCount = VISIBLE_STEP;
    this.load(this.attrs.gbifId);
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);
    if (vnode.attrs.gbifId !== this.attrs.gbifId) {
      this.load(vnode.attrs.gbifId);
    }
  }
  load(gbifId) {
    this.items = null;
    this.visibleCount = VISIBLE_STEP;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/' + this.attrs.endpoint,
      params: {
        filter: {
          gbifId
        }
      }
    }).then(response => {
      this.items = (response.data || []).map(item => ({
        id: item.id,
        ...item.attributes
      }));
      m.redraw();
    }).catch(() => {
      this.items = [];
      m.redraw();
    });
  }
  view() {
    if (!this.items || this.items.length === 0) {
      return null;
    }
    const visible = this.items.slice(0, this.visibleCount);
    return [m("div", {
      className: this.attrs.sectionClass
    }, m("h2", {
      className: "ChampisSpeciesSearch-label"
    }, app.translator.trans(this.attrs.headerKey)), m("ul", null, visible.map(item => m("li", {
      key: item.id
    }, m(Link, {
      href: item.colId ? app.route.taxon(item.colId, item.canonicalName) : app.route.species(item.gbifId, item.pageSlug || item.canonicalName),
      className: "SpeciesPage-referenceLink"
    }, speciesName(item)))))), visible.length < this.items.length && m("div", {
      className: this.attrs.loadMoreClass
    }, m(Button, {
      className: "Button",
      onclick: () => this.visibleCount += VISIBLE_STEP
    }, app.translator.trans('champis-species.forum.species_page.load_more_button')))];
  }
}
flarum.reg.add('champis-species', 'forum/components/SpeciesReferenceBox', SpeciesReferenceBox);